import Joi from 'joi';
import { BulkEmailConfig, BulkEmailTaskTarget } from '../interface/interface';

const filterValidationSchema = Joi.object({
  isPicked: Joi.boolean().optional(),
  filterBy: Joi.string().optional().allow(null),
  startDate: Joi.date().when('filterBy', {
    is: Joi.exist(),
    then: Joi.required(),
    otherwise: Joi.optional().allow(null),
  }),
  endDate: Joi.date().when('filterBy', {
    is: 'BETWEEN',
    then: Joi.required(),
    otherwise: Joi.optional().allow(null),
  }),
});

export const bulkEmailPayloadValidator = (formData: BulkEmailConfig) => {
  let schema;
  if (formData.target === BulkEmailTaskTarget.Patient) {
    schema = Joi.object()
      .keys({
        target: Joi.string().required(),
        template: Joi.string().required(),
        active: Joi.boolean().required(),
        internal: Joi.boolean().required(),
        registered: filterValidationSchema,
        invited: filterValidationSchema,
        ignoreIfAlreadySent: Joi.boolean().optional(),
      })
      .required();
  } else {
    schema = Joi.object()
      .keys({
        target: Joi.string().required(),
        template: Joi.string().required(),
        prescriptionStatus: Joi.string().required(),
        product: Joi.number().required(),
        ignoreIfAlreadySent: Joi.boolean().optional(),
      })
      .required();
  }

  const { error } = schema.validate(formData, { abortEarly: false });
  console.log(error, 'error');

  return error ? error.details : false;
};
